/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PGAModelBuilderModelPlayersQueryVariables = {|
  modelID: string
|};
export type PGAModelBuilderModelPlayersQueryResponse = {|
  +playersMatchingPgaModel: ?$ReadOnlyArray<?{|
    +player: ?{|
      +fullName: ?string
    |},
    +numRounds: ?number,
  |}>
|};
export type PGAModelBuilderModelPlayersQuery = {|
  variables: PGAModelBuilderModelPlayersQueryVariables,
  response: PGAModelBuilderModelPlayersQueryResponse,
|};
*/


/*
query PGAModelBuilderModelPlayersQuery(
  $modelID: ID!
) {
  playersMatchingPgaModel(modelId: $modelID) {
    player {
      fullName
      id
    }
    numRounds
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "modelID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "modelId",
    "variableName": "modelID"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numRounds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAModelBuilderModelPlayersQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PGATourModelPlayerMatchRowType",
        "kind": "LinkedField",
        "name": "playersMatchingPgaModel",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourPlayerType",
            "kind": "LinkedField",
            "name": "player",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PGAModelBuilderModelPlayersQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PGATourModelPlayerMatchRowType",
        "kind": "LinkedField",
        "name": "playersMatchingPgaModel",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourPlayerType",
            "kind": "LinkedField",
            "name": "player",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "31978c6243a6b8684fddfa2cdc673770",
    "id": null,
    "metadata": {},
    "name": "PGAModelBuilderModelPlayersQuery",
    "operationKind": "query",
    "text": "query PGAModelBuilderModelPlayersQuery(\n  $modelID: ID!\n) {\n  playersMatchingPgaModel(modelId: $modelID) {\n    player {\n      fullName\n      id\n    }\n    numRounds\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3a2ddaf6cea793c09d3732c2aa7004de';

module.exports = node;
